import DDIIcon from "./ddi_icon";
import { useTranslation } from "react-i18next";

export const DDILegendWithText = () => {
  const { t } = useTranslation();
  return (
    <>
      <hr className="m-4" />
      <p>
        {t(
          "auto.osMedicamentosDeDeterminadoGrupoFarmacologicoSaoClassificadosEm4CategoriasDeCoresQueSeAproximamAsCoresDeUmSemaforoDependendoDoRiscoDeInteracoesMedicamentosasDDIsComOsInibidoresDeCDK46CDK46i",
          "Os medicamentos de determinado grupo farmacológico são classificados em 4 categorias de cores, que\n        se aproximam às cores de um semáforo, dependendo do risco de interações medicamentosas\n        (DDIs) com os inibidores de CDK4/6 (CDK 4/6i):",
        )}
      </p>
      <p className="ps-3">
        <DDIIcon value={0} />{" "}
        <span className="ms-2">
          <strong>
            {t("auto.interacaoNaoEsperada", "Interação não esperada")}
          </strong>
        </span>
        <br />
        <DDIIcon value={1} />{" "}
        <span className="ms-2">
          <strong>
            {t(
              "auto.interacaoDeBaixoPotencial",
              "Interação de baixo potencial",
            )}
          </strong>
        </span>
        <br />
        <DDIIcon value={2} />{" "}
        <span className="ms-2">
          <strong>
            {t("auto.interacaoPotencialForte", "Interação potencial forte")}
          </strong>
        </span>
        <br />
        <DDIIcon value={3} />{" "}
        <span className="ms-2">
          <strong>
            {t(
              "auto.interacaoPotencialForteComAjusteDose",
              "Interação potencial forte com ajuste de dose",
            )}
          </strong>
        </span>
        <br />
        <DDIIcon value={4} />{" "}
        <span className="ms-2">
          <strong>{t("auto.naoCoadministrar", "Não coadministrar")}</strong>
        </span>
        <br />
      </p>
    </>
  );
};
